import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store';
import { getlocalStorageToken } from '../utils/auth';

Vue.use(VueRouter)

function loadView(path) {
  return () => import(`../views/${path}`);
}

const routes = [
  {
    path: '/',
    redirect: '/intro',
  },

  {
    path: '/intro',
    name: 'Intro',
    component: loadView('IntroView.vue'),
  },

  {
    path: '/term',
    name: 'Term',
    component: loadView('TermView.vue')
  },

  {
    path: '/test',
    name: 'Test',
    component: loadView('Test.vue')
  },

  {
    path: '/main',
    name: 'Main',
    component: loadView('main/MainView.vue')
  },

  {
    path: '/login',
    name: 'Login',
    meta: { authority: false, },
    component: loadView('LoginView.vue')
  },

  {
    path: '/nice',
    name: 'Nice',
    component: loadView('NicePopupView.vue')
  },

  {
    path: '/niceCallback',
    name: 'NiceCallback',
    component: loadView('NicePopupView.vue')
  },
  // {
  //   path: '/niceCallback',
  //   name: 'NiceCallback',
  //   component: loadView('NiceCallbackView.vue')
  // },

  {
    path: '/kakaoSignIn',
    name: 'KakaoSignIn',
    component: loadView('KakaoPopupView.vue')
  },

  // {
  //   path: '/kakaoLogin',
  //   name: 'KakaoLogin',
  //   component: loadView('KakaoPopupView.vue')
  // },

  // {
  //   path: '/kakaoCallback',
  //   name: 'KakaoCallback',
  //   component: loadView('KakaoPopupView.vue')
  // },

  {
    path: '/googleSignIn',
    name: 'GoogleSignIn',
    component: loadView('GooglePopupView.vue')
  },

  {
    path: '/appleSignIn',
    name: 'AppleSignIn',
    component: loadView('ApplePopupView.vue')
  },



  // {
  //   path: '/googleSignIn',
  //   name: 'GoogleSignIn',
  //   component: loadView('GooglePopupView.vue')
  // },

  // {
  //   path: '/loginKakao',
  //   name: 'LoginKakao',
  //   component: loadView('KakaoCallbackView.vue')
  // },

  // {
  //   path: '/connectKakao',
  //   name: 'ConnectKakao',
  //   component: loadView('KakaoCallbackView.vue')
  // },

  // {
  //   path: '/joinConnectKakao',
  //   name: 'JoinConnectKakao',
  //   component: loadView('KakaoCallbackView.vue')
  // },



  // {
  //   path: '/callbackGoogle',
  //   name: 'GoogleCallback',
  //   component: loadView('GooglePopupView.vue')
  // },

  // {
  //   path: '/loginGoogle',
  //   name: 'LoginGoogle',
  //   component: loadView('GoogleCallbackView.vue')
  // },

  // {
  //   path: '/connectGoogle',
  //   name: 'ConnectGoogle',
  //   component: loadView('GoogleCallbackView.vue')
  // },

  // {
  //   path: '/joinConnectGoogle',
  //   name: 'JoinConnectGoogle',
  //   component: loadView('GoogleCallbackView.vue')
  // },
  

  {
    path: '/menu',
    name: 'Menu',
    component: loadView('menu/MenuView.vue')
  },


  {
    path: '/join',
    component: loadView('join/JoinView.vue'),
    children: [
      {
        path: 'name',
        name: 'JoinName',
        meta: {
          authority: false,
          type: 'join',
        },
        component: loadView('join/JoinNameView.vue'),
      },
      {
        path: 'niceAuth',
        name: 'JoinNiceAuth',
        meta: {
          authority: false,
          type: 'join',
        },
        component: loadView('join/JoinNiceAuthView.vue'),
      },
      {
        path: 'password',
        name: 'JoinPassword',
        meta: {
          authority: false,
          type: 'join',
        },
        component: loadView('join/JoinPasswordView.vue'),
      },
      {
        path: 'terms',
        name: 'JoinTerms',
        meta: {
          authority: false,
          type: 'join',
        },
        component: loadView('join/JoinTermsView.vue'),
      },
      {
        path: 'social',
        name: 'JoinSocial',
        meta: {
          authority: true,
          type: 'join',
        },
        component: loadView('join/JoinSocialView.vue'),
      },
      {
        path: 'complete',
        name: 'JoinComplete',
        meta: {
          authority: true,
          type: 'join',
        },
        component: loadView('join/JoinCompleteView.vue'),
      },
    ]
  },

  {
    path: '/pw',
    component: loadView('change/pw/PwView.vue'),
    children: [
      {
        path: 'niceAuth',
        name: 'PwNiceAuth',
        meta: {
          authority: false,
        },
        component: loadView('change/pw/PwNiceAuthView.vue'),
      },
      {
        path: 'change',
        name: 'PwChange',
        meta: {
          authority: false,
        },
        component: loadView('change/pw/PwChangeView.vue'),
      },
    ]
  },

  {
    path: '/phone',
    component: loadView('change/phone/PhoneView.vue'),
    children: [
      {
        path: 'pwChk',
        name: 'PhonePwChk',
        meta: {
          authority: true,
        },
        component: loadView('change/phone/PhonePwChkView.vue'),
      },
      {
        path: 'niceAuth',
        name: 'PhoneNiceAuth',
        meta: {
          authority: true,
        },
        component: loadView('change/phone/PhoneNiceAuthView.vue'),
      },
      {
        path: 'complete',
        name: 'PhoneComplete',
        meta: {
          authority: true,
        },
        component: loadView('change/phone/PhoneCompleteView.vue'),
      },
    ]
  },

  {
    path: '/myInfo',
    name: 'MyInfo',
    meta: {
      authority: true,
    },
    component: loadView('my/MyInfoView.vue')
  },

  {
    path: '/myReview',
    name: 'MyReview',
    meta: {
      authority: true,
    },
    component: loadView('my/MyReviewView.vue')
  },

  {
    path: '/brandList',
    name: 'BrandList',
    component: loadView('brand/BrandListView.vue')
  },
  {
    path: '/brandSelect',
    name: 'BrandSelect',
    component: loadView('brand/BrandListView.vue')
  },


  {
    path: '/dealerList/:brandId',
    name: 'DealerList',
    component: loadView('dealer/DealerListView.vue')
  },
  {
    path: '/dealerInfo/:dealerId',
    name: 'DealerInfo',
    component: loadView('dealer/DealerInfoView.vue')
  },
  {
    path: '/dealerShop/:dealerId',
    name: 'DealerShop',
    component: loadView('dealer/DealerShopView.vue')
  },



  {
    path: '/shopInfo/:shopId',
    name: 'ShopInfo',
    component: loadView('shop/ShopInfoView.vue')
  },
  {
    path: '/shopSc/:shopId',
    name: 'ShopSc',
    component: loadView('shop/ShopScView.vue')
  },
  {
    path: '/shopReview/:shopId',
    name: 'ShopReview',
    component: loadView('shop/ShopReviewView.vue')
  },



  {
    path: '/vehicleInfo/:trimId',
    name: 'VehicleInfo',
    component: loadView('vehicle/VehicleInfoView.vue')
  },

  {
    path: '/vehicleList/:brandId',
    name: 'VehicleList',
    component: loadView('vehicle/VehicleListView.vue')
  },

  {
    path: '/vehicleReview/:trimId',
    name: 'VehicleReview',
    component: loadView('vehicle/VehicleReviewView.vue')
  },

  {
    path: '/scList',
    name: 'ScList',
    meta: {
      authority: true,
      type: 'booking',
    },
    component: loadView('sc/ScListView.vue')
  },

  {
    path: '/scList/:bookingId',
    name: 'ScList',
    meta: {
      authority: true,
      type: 'booking',
    },
    component: loadView('sc/ScListView.vue')
  },


  {
    path: '/scInfo/:scId',
    name: 'ScInfo',
    component: loadView('sc/ScInfoView.vue')
  },
  {
    path: '/scReview/:scId',
    name: 'ScReview',
    component: loadView('sc/ScReviewView.vue')
  },

  {
    path: '/booking',
    component: loadView('booking/BookingView.vue'),
    children: [
      //예약 변경
      {
        path: 'inputBasic/:bookingId',
        name: 'BookingChangeInputBasic',
        meta: {
          authority: true,
          type: 'booking',
        },
        component: loadView('booking/BookingInputBasicView.vue'),
      },
      {
        path: 'selectVehicle/:brandId/:bookingId',
        name: 'BookingChangeSelectVehicle',
        meta: {
          authority: true,
          type: 'booking',
        },
        component: loadView('vehicle/VehicleListView.vue')
      },
      {
        path: 'inputDetail/:bookingId',
        name: 'BookingChangeInputDetail',
        meta: {
          authority: true,
          type: 'booking',
        },
        component: loadView('booking/BookingInputDetailView.vue'),
      },
      {
        path: 'inputDate/:bookingId',
        name: 'BookingChangeInputDate',
        meta: {
          authority: true,
          type: 'booking',
        },
        component: loadView('booking/BookingInputDateView.vue'),
      },
      {
        path: 'scRecommendResult/:bookingId',
        name: 'BookingChangeScRecommendResult',
        meta: {
          authority: true,
          type: 'booking',
        },
        component: loadView('sc/ScRecommendResultView.vue')
      },

      {
        path: 'inputVehicle/:bookingId',
        name: 'BookingChangeInputVehicle',
        meta: {
          authority: true,
          type: 'booking',
        },
        component: loadView('booking/BookingInputVehicleView.vue'),
      },

      //예약 생성
      {
        path: 'inputBasic',
        name: 'BookingInputBasic',
        meta: {
          authority: true,
          type: 'booking',
        },
        component: loadView('booking/BookingInputBasicView.vue'),
      },
      {
        path: 'selectVehicle/:brandId',
        name: 'BookingSelectVehicle',
        meta: {
          authority: true,
          type: 'booking',
        },
        component: loadView('vehicle/VehicleListView.vue')
      },
      {
        path: 'inputDetail',
        name: 'BookingInputDetail',
        meta: {
          authority: true,
          type: 'booking',
        },
        component: loadView('booking/BookingInputDetailView.vue'),
      },
      {
        path: 'inputDate',
        name: 'BookingInputDate',
        meta: {
          authority: true,
          type: 'booking',
        },
        component: loadView('booking/BookingInputDateView.vue'),
      },
      {
        path: 'scRecommendResult',
        name: 'BookingScRecommendResult',
        meta: {
          authority: true,
          type: 'booking',
        },
        component: loadView('sc/ScRecommendResultView.vue')
      },
      {
        path: 'inputVehicle',
        name: 'BookingInputVehicle',
        meta: { 
          authority: true,
          type: 'booking',
        },
        component: loadView('booking/BookingInputVehicleView.vue'),
      },

      {
        path: 'kakaoJuso',
        name: 'BookingInputKakaoJuso',
        meta: { 
          authority: true,
          type: 'booking',
        },
        component: loadView('booking/KakaoJusoView.vue')
      },

      {
        path: 'kakaoJuso/:bookingId',
        name: 'BookingChangeKakaoJuso',
        meta: { 
          authority: true,
          type: 'booking',
        },
        component: loadView('booking/KakaoJusoView.vue')
      },
    ]
  },

  {
    path: '/reviewScInput/:bookingId',
    name: 'ReviewScInput',
    meta: {
      authority: true,
    },
    component: loadView('booking/ReviewInputView.vue')
  },

  {
    path: '/reviewShopInput/:bookingId',
    name: 'ReviewShopInput',
    meta: {
      authority: true,
    },
    component: loadView('booking/ReviewInputView.vue')
  },

  {
    path: '/reviewTrimInput/:bookingId',
    name: 'ReviewTrimInput',
    meta: {
      authority: true,
    },
    component: loadView('booking/ReviewInputView.vue')
  },

  {
    path: '/myBookingList',
    name: 'MyBookingList',
    meta: {
      authority: true,
    },
    component: loadView('booking/BookingListView.vue')
  },

  {
    path: '/myBooking/:bookingId',
    name: 'MyBooking',
    meta: {
      authority: true,
    },
    component: loadView('booking/BookingItemView.vue')
  },
  {
    path: '/myBookingReview/:bookingId',
    name: 'MyBookingReview',
    meta: {
      authority: true,
    },
    component: loadView('booking/BookingItemReview.vue')
  },


  {
    path: '/newsList',
    name: 'NewsList',
    component: loadView('news/NewsListView.vue')
  },

  {
    path: '/newsInfo/:boardId',
    name: 'NewsInfo',
    component: loadView('news/NewsInfoView.vue')
  },

  {
    path: '/faqList',
    name: 'FaqList',
    component: loadView('faq/FaqListView.vue')
  },
  
  {
    path: '/faqInfo/:faqId',
    name: 'FaqInfo',
    component: loadView('faq/FaqInfoView.vue')
  },

  {
    path: '/noticeList',
    name: 'NoticeList',
    component: loadView('notice/NoticeListView.vue')
  },
  {
    path: '/noticeInfo/:noticeId',
    name: 'NoticeInfo',
    component: loadView('notice/NoticeInfoView.vue')
  },

  {
    path: '/qna',
    component: loadView('qna/QnaView.vue'),
    children: [
      {
        path: '',
        name: 'QnaList',
        meta: {
          authority: true,
        },
        component: loadView('qna/QnaListView.vue'),
      },
      {
        path: 'create',
        name: 'QnaCreate',
        meta: {
          authority: true,
        },
        component: loadView('qna/QnaCreateView.vue'),
      },
      {
        path: ':qnaId',
        name: 'QnaInfo',
        meta: {
          authority: true,
        },
        component: loadView('qna/QnaInfoView.vue'),
      },
    ]
  },

  {
    path: '/privacyList',
    name: 'privacyList',
    component: loadView('privacy/privacyListView.vue'),
  },

  {
    path: '/termList',
    name: 'termList',
    component: loadView('privacy/termListView.vue'),
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // scrollBehavior () { //to, from, savedPosition
  //   return { x: 0, y: 0 }
  // },
})

function loginChk() {
  let token = getlocalStorageToken();
  let login_auth = store.state.auth.item;
  return (
    token != null &&
    token != '' && 
    login_auth != null &&
    login_auth.id > 0
  );
}

function storeReset() {
  store.commit('RESET_HEADER');
  store.commit('RESET_FOOTER');
  store.commit('RESET_ROUTE_BACK');
  store.commit('HIDE_ONLOAD');
}

function nextSubmit(to, from, next, path = null) {
  storeReset();
  // console.log("============================")
  // console.log("routeBack:: ", store.state.routeBack)
  // console.log("router move", `${from.path}(${from.name})` + '  ====> ' + `${to.path}(${to.name})` )
  // console.log("============================")
  store.commit('END_ROUTE_LOADING');
  if(path) return next(path);
  return next();
}

router.beforeEach((to, from, next) => {
  store.commit('START_ROUTE_LOADING');
  if(typeof to.meta.authority == 'undefined') 
    return nextSubmit(to, from, next);

  //로그인된 상태일 경우
  if(loginChk()) {

    if(!to.meta.authority) {
      store.commit('OPEN_MODAL', {
        content: '이미 로그인된 상태입니다.',
        btnOne: '확인',
      });

      if( 
        typeof from.meta != 'undefined' && 
        typeof from.meta.authority != 'undefined' &&
        !from.meta.authority 
      ) {
        return nextSubmit(to, from, next, '/main');
      } 

      if(from.name == null) 
        return nextSubmit(to, from, next, '/main');

      return nextSubmit(false);
    } 

  }

  // 비로그인 상태일 경우
  else {

    if(to.meta.authority) {
      return store.commit('OPEN_MODAL', {
        content: '로그인후 사용가능 합니다.',
        btnOne: '확인',
        btnOneSubmit: () => {
          return nextSubmit(to, from, next, '/login');
        }
      });
    }

  }

  return nextSubmit(to, from, next);
});


export default router
